import { FormattedMessage } from "react-intl";
import { Button } from "@shltelemedicine/shl-ui-lib";
import styles from "./OfflineBanner.module.css";
import { ReactComponent as OfflineAlertIcon } from "../../../assets/shared/offline_alert_icon.svg";

const OfflineBanner = () => (
  <div
    className={`d-flex justify-content-around w-25 z-index-max ${styles.offlineBanner}`}
  >
    <Button
      className={`${styles.offlineButton} d-flex`}
      variant=""
      customIcon={<OfflineAlertIcon />}
    >
      <FormattedMessage id="GLOBAL.OFFLINE" defaultMessage="Offline" />
    </Button>
  </div>
);

export default OfflineBanner;
